<template>
  <div class="container" id="library-hover-box" @click.stop :style="{'top': jobTabCardDialogTop + 'px'}" @mouseenter="showFixed" @mouseleave="hiddenFixed">
    <!-- extras-其他模块 -->
    <template v-if="type === 'extras'">
      <div class="library-item-content">
        <div class="item-desc" v-html="itemData.description"
             v-if="itemData.description"></div>
        <div class="operation-container flex">
          <div class="btn operation-date" @click.stop="debounce(() => deleteExperience(), 200)">
            删除经历
          </div>
          <div class="btn operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(), 500)">
            {{ itemData.isSelect ? '已使用' : '使用经历' }}
          </div>
        </div>
      </div>
    </template>
    <!-- 除去其他模块 -->
    <template v-else-if="itemData">
      <template v-if="type !== 'personal_summary' && type !== 'skill_list'">
        <div class="item-name text-overflow" v-if="itemData && (itemData.company || itemData.university || itemData.name)">
          {{itemData.company || itemData.university || itemData.name}}
        </div>
        <div class="item-info text-overflow"
             v-if="type === 'edus' && (itemData.city || itemData.major || itemData.degree || itemData.uni_school)">
          <span v-if="itemData.city">{{itemData.city}}</span>
          <span v-if="itemData.major">{{itemData.major}}</span>
          <span v-if="itemData.degree">{{itemData.degree}}</span>
          <span v-if="itemData.uni_school">{{itemData.uni_school}}</span>
        </div>
        <div class="item-info text-overflow" v-else-if="itemData.city || itemData.title || itemData.dept">
          <span v-if="itemData.city">{{itemData.city}}</span>
          <span v-if="itemData.title">{{itemData.title}}</span>
          <span v-if="itemData.dept">{{itemData.dept}}</span>
        </div>
        <div class="item-desc" v-if="itemData.description" v-html="itemData.description"></div>
        <div class="operation-container flex">
          <div class="btn operation-date" @click.stop="debounce(() => deleteExperience(), 200)">
            删除经历
          </div>
          <div class="btn operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(), 500)">
            {{ itemData.isSelect ? '已使用' : '使用经历' }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="item-desc" v-if="itemData.description" v-html="itemData.description"></div>
        <div class="operation-container flex">
          <div class="btn operation-date" @click.stop="debounce(() => deleteExperience(), 200)">
            删除经历
          </div>
          <div class="btn operation-btn" :class="{'operation-btn-disabled': itemData.isSelect}" @click="debounce(() => selectExperience(), 500)">
            {{ itemData.isSelect ? '已使用' : '使用经历' }}
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { timeFormatFilter, debounce, copyToClip } from '@/assets/js/util'
import moment from 'moment'
import { componentsMixin } from '@/assets/js/mixins/components'
import { mapState, mapMutations } from 'vuex'
export default {
  name: "LibraryHoverBox",
  mixins: [ componentsMixin ],
  computed: {
    ...mapState('editor', [ 'jobTabCardDialogTimer', 'jobTabCardContentScrollY', 'showJobTabCardDialog', 'showJobTabCardDialogSelf', 'showJobTabCardDialogData', 'jobTabCardDialogTop' ]),
    itemData() {
      return this.showJobTabCardDialogData.data
    },
    index() {
      return this.showJobTabCardDialogData.index
    },
    type() {
      return this.showJobTabCardDialogData.type
    },
    bKey() {
      return this.showJobTabCardDialogData.bKey
    }
  },
  methods: {
    ...mapMutations('editor', ['setJobTabCardDialogTimer', 'setJobTabCardDialogTop', 'setShowJobTabCardDialog', 'setShowJobTabCardDialogSelf', 'setShowJobTabCardDialogData']),
    moment,
    timeFormatFilter,
    showFixed () {
      this.setShowJobTabCardDialogSelf(true)
    },
    hiddenFixed () {
      this.setShowJobTabCardDialogSelf(false)
    },
    // 删除经历
    deleteExperience() {
      this.$emit('deleteExperience', this.itemData, this.index, this.bKey, this.type, this.showJobTabCardDialogData.experienceIndex)
    },
    // 选择经历同步
    selectExperience() {
      this.$emit('selectExperience', this.itemData, this.index, this.bKey, this.type, this.showJobTabCardDialogData.experienceIndex)
    },
    // 防抖
    debounce (fn, timeInterval) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      let arg = [ ...arguments ].filter((item, index) => {
        return index > 1
      })
      this.timer = setTimeout(() => {
        fn.apply(this, arg)
      }, timeInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 300px;
  padding: 16px 16px 0;
  cursor: default;
  position: absolute;
  top: 142px;
  left: -290px;
  z-index: 3;
  background: #fff;
  // box-shadow: 0 2px 16px 0 rgba(10, 44, 156, 0.14);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);;
  border-radius: 6px;
  color: #505667;


  //width: 100%;
  //padding: 20px 16px 0;
  //position: relative;
  //background: #F5F6FA;
  //border-radius: 8px;
  ////overflow: hidden;
  //box-sizing: border-box;
  //margin-top: 12px;
  //color: #505667;
  &:first-child {
    margin-top: 0;
  }
  &:hover {
    .library-item-delete {
      display: block;
    }
  }
  &.disabled{
    opacity: 0.6;
  }
  .item-name {
    font-size: 16px;
    color: #505667;
    font-weight: 600;
    word-wrap:break-word;
  }
  .item-info {
    display: flex;
    word-wrap:break-word;
    margin-top: 14px;
    font-weight: 500;
    span {
      display: flex;
      &::after {
        content: "|";
        display: block;
        width: 10px;
        font-size: 12px;
        text-align: center;
      }
      &:last-child::after {
        content: "";
        width: 0;
      }
    }
  }
  .item-desc {
    width: 100%;
    height: 191px;
    line-height: 22px;
    margin-top: 8px;
    overflow-y: auto;
  }
  .operation-container {
    width: 100%;
    height: 62px;
    margin-top: 12px;
    //border-top: 1px dashed #AEB2BD;
    align-items: center;
    justify-content: space-between;
    .btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
      border: 1px solid #679CFF;
      font-size: 14px;
      cursor: pointer;
      box-sizing: border-box;
      line-height: 36px;
      text-align: center;
    }
    .operation-date {
      color: #679CFF;
      &:hover{
        background: rgba(103, 156, 255, 1);
        color: #fff;
      }
    }
    .operation-btn {
      color: #fff;
      background-color: #679CFF;
      &-disabled {
        opacity: 0.4;
        //cursor: not-allowed;
      }
      &:hover{
        background: #4183FF;
      }
    }
  }
  .library-item-delete {
    display: none;
    font-size: 14px;
    color: #AEB2BD;
    position: absolute;
    top: 22px;
    right: 20px;
    cursor: pointer;
    .tooltip {
      width: 100px;
      display: flex;
      position: absolute;
      top: -20px;
      left: 0;
      color: green;
      font-size: 12px;
    }
    i {
      font-weight: 600;
    }
    &:hover{
      color: #505667;
    }
  }
  .item-date {
    position: absolute;
    right: 24px;
    bottom: 14px;
    text-align: right;
    font-size: 12px;
    color: #AEB2BD;
  }
}
.noMarginTop {
  margin-top: 0;
}
</style>
